export default "__VITE_ASSET__Ca6tDXMR__"